/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileContactResponse } from './profileContactResponse';

export interface ContactRevealResponse {
  contacts: ProfileContactResponse[];
  credits_remaining: number;
  already_revealed: boolean;
}
